import Player from 'react-player';

import styles from './external-video.module.scss';

export default function ExternalVideo({ data }: { data: any }) {
  const { video, layout } = data;
  const { width, height } = video;

  return (
    <div style={{ padding: layout === 'full' ? '0' : '0 40px' }}>
      <div className={styles.video} style={{ paddingTop: `${(height / width) * 100}%` }}>
        <Player src={video.url} controls={true} />
      </div>
    </div>
  );
}
